'use client'

import { useTranslation } from 'react-i18next'
import { RegisterForm } from '@/features/auth/ui/RegisterForm'
import { AuthLayout } from './AuthLayout'

export function RegisterPage() {
  const { t } = useTranslation()
  return (
    <AuthLayout
      title={t('auth.register.title')}
      description={t('auth.register.description')}
    >
      <RegisterForm />
    </AuthLayout>
  )
}
